import {createContext, useContext} from 'react'

import type {ReactNode} from 'react'
import type {ExternalLinkDisclaimerConfigFragment} from '@sdox/api'

type ExternalLinkDisclaimerContextState = {
  config: ExternalLinkDisclaimerConfigFragment | null
}

interface ExternalLinkDisclaimerContextProviderProps {
  value: ExternalLinkDisclaimerContextState
  children?: ReactNode
}

const ExternalLinkDisclaimerContext = createContext<ExternalLinkDisclaimerContextState>({config: null})

export const ExternalLinkDisclaimerProvider = (props: ExternalLinkDisclaimerContextProviderProps) => {
  const {children, value} = props
  return (
    <ExternalLinkDisclaimerContext.Provider value={value}>
      {children}
    </ExternalLinkDisclaimerContext.Provider>
  )
}

export const useExternalLinkDisclaimerConfig = () => {
  const context = useContext(ExternalLinkDisclaimerContext)
  if (context === undefined) {
    throw Error('useExternalLinkDisclaimerConfig was used outside a context provider.')
  }
  return context.config
}
